<template>
  <q-card
    class="card-schedule"
    style="background-color: #f2f2f2"
  >
    <div
      class="flex row justify-between items-center"
      style="padding: 16px 16px 0 16px"
    >
      <span class="provision">Agendamento</span>
      <div class="flex row justify-between items-center col-4">
        <q-btn
          data-testid="agenda-discar"
          v-if="!isPaused && !isMail"
          flat
          dense
          size="md"
          icon="mdi-phone-outgoing-outline"
          color="green-8"
          :disable="invalidContactNumber"
          @click="handleNewCall "
        >
          <q-tooltip>Discar para o contato</q-tooltip>
        </q-btn>

        <ListBrokers
          v-if="!isPaused && !isMail"
          size="11px"
          @on-template-select="handleStartChat"
          :rounded="false"
          :outlined="false"
          :disable-list="invalidContactNumber"
          class-name="q-pa-none"
        />

        <q-btn
          data-testid="agenda-enviar-email"
          v-if="!isPaused"
          dense
          round
          flat
          size="sm"
          icon="mdi-email-plus-outline"
          color="blue-10"
          :disable="isPaused || contactIsNotEmail"
          @click="handleStartMail"
        >
          <q-tooltip>Enviar mensagem</q-tooltip>
        </q-btn>
      </div>

      <q-btn
        data-testid="agenda-excluir"
        v-if="!isPaused"
        dense

        flat
        size="sm"
        icon="mdi-trash-can-outline"
        color="negative"
        :disable="isPaused"
        @click="removeAppointment"
      >
        <q-tooltip>Excluir</q-tooltip>
      </q-btn>
    </div>
    <PanelEvent
      ref="eventPanel"
      @form-error="updateSaveButton"
      :event-details="eventDetails"
      @update-contact="updateContact"
      :edit-template="true"
      :is-paused="isPaused"
    />

    <q-card-section class="row justify-between">
      <q-btn
        data-testid="agenda-cancelar"
        color="primary"
        label="Cancelar"
        no-caps
        flat
        v-close-popup
      />

      <q-btn
        data-testid="agenda-reagendar"
        color="primary"
        label="Reagendar"
        no-caps
        :disable="disableSave"
        :loading="loadingState"
        @click="handleEditEvents"
      />
    </q-card-section>
  </q-card>
</template>

<script>
import { startChat } from '@/libs/startAttendance'
import ListBrokers from '@/components/ListBrokers'
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment-timezone'
import PanelEvent from './PanelEvent.vue'
import AskTemplateParams from './AskTemplateParams.vue'
import AskTemplateQueue from '@/components/AskTemplateQueue'

moment.locale('pt-br')

export default {
  components: {
    ListBrokers,
    PanelEvent
  },

  props: {
    eventDetails: {},
    isPaused: {},
    agentId: {}
  },

  data () {
    return {
      attendanceParsed: this.attendance(),
      tab: 'Evento',
      loadingState: false,
      disableSave: false,
      contact: this.eventDetails?.contact
    }
  },

  computed: {

    channel () {
      return this.attendanceParsed?.channel
    },

    isMail () {
      return this.channel === 'MAIL'
    },

    isVoice () {
      return this.channel === 'VOICE'
    },

    isChat () {
      return this.channel === 'TEXT'
    },

    contactIsNotEmail () {
      if (!this.contact) return true
      const emailContact = this.contact.split(', ')
      let allContactsAreMail = false
      emailContact.forEach(contact => {
        const validEmail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
        if (validEmail.test(contact) === false) allContactsAreMail = true
      })
      return allContactsAreMail
    },

    eventSavedContact () {
      return this.eventDetails?.contact
    },

    invalidContactNumber () {
      if (!this.contact) return true
      const isEmpty = this.contact.trim() === ''
      const hasInvalidChars = !/^[0-9*]+$/.test(this.contact)
      const hasChars = !/^\d+$/.test(this.contact)
      const invalidcontact = this.contact.length < 8
      return isEmpty || hasInvalidChars || hasChars || invalidcontact
    },

    getEventPanelData () {
      const formInfo = this.$refs.eventPanel.getFormData()
      return formInfo
    },

    ...mapGetters({
      templates: 'agentModule/getTemplates'
    })

  },

  methods: {
    attendance () {
      return this.eventDetails.attendanceInfo
        ? JSON.parse(this.eventDetails.attendanceInfo)
        : null
    },

    ...mapActions({
      startMail: 'attendanceModule/startMail',
      call: 'sipModule/call'
    }),

    async removeAppointment () {
      const id = this.eventDetails.id
      this.$q.dialog({
        title: 'Confirme a ação',
        message: 'Essa ação não poderá ser desfeita. Deseja continuar?',
        cancel: {
          label: 'Cancelar',
          color: 'primary'
        },
        ok: {
          label: 'Deletar',
          color: 'red-8'
        },
        persistent: true
      }).onOk(async () => {
        const newAppointments = await this.$store.dispatch('calendarModule/deleteAppointments', { idArray: [id] })
        this.$emit('close-card', newAppointments)
      })
    },

    async handleEditEvents () {
      this.loadingState = true
      const { title, description, contact, backgroundColor, startDate, endDate, notificationTimeBefore } = this.getEventPanelData
      const templateToSend = this.getEventPanelData.templateToSend

      const editedAppointment = {
        ...this.eventDetails,
        configs: {
          title,
          description,
          backgroundColor,
          notificationTimeBefore,
          templateToSend
        },
        startDate,
        endDate,
        contact,
        templateId: templateToSend?.id ?? null
      }

      if (templateToSend) {
        const originalTemplate = this.templates.find(t => t.id === templateToSend.id)
        const updatedTemplate = await this.handleScheduleTemplate(originalTemplate)
        if (!updatedTemplate) {
          this.loadingState = false
          return
        }
        editedAppointment.configs.templateToSend = updatedTemplate
      }

      const newAppointments = await this.$store.dispatch('calendarModule/patchAppointments', editedAppointment)
      this.loadingState = false
      this.$emit('close-card', newAppointments)
    },

    async handleScheduleTemplate (originalTemplate) {
      const template = { ...originalTemplate }
      const hasParams = template?.params?.length || template?.params?.params?.length
      const queues = Array.isArray(template.queues) ? template.queues.map(({ queueId, queueName }) => ({ id: queueId, label: queueName })) : []
      const agent = this.$store.state?.agentModule?.session?.agent

      if (hasParams) {
        const result = await new Promise(resolve => {
          this.$q.dialog({ parent: this, template, agent, schedule: true, component: AskTemplateParams })
            .onOk(({ queueId, fields, header }) => {
              template.queueId = queueId
              template.fields = fields
              template.header = header
              resolve(template)
            })
            .onCancel(() => resolve(null))
        })

        return result
      }

      if (queues.length > 1 && !hasParams) {
        const result = await new Promise(resolve => {
          this.$q.dialog({ parent: this, template, agent, schedule: true, component: AskTemplateQueue })
            .onOk(({ queueId }) => {
              template.queueId = queueId
              resolve(template)
            })
            .onCancel(() => resolve(null))
        })

        return result
      }

      return template
    },

    handleNewCall () {
      this.call(this.contact)
    },

    handleStartChat (template) {
      const vm = this
      const templateId = template.id
      const destination = vm.attendanceParsed?.sourceId ?? vm.contact
      startChat(vm, destination, templateId, template)
      this.$emit('close-card')
    },

    handleStartMail () {
      const rawContacts = this.contact || ''
      const contactList = rawContacts.includes(',')
        ? rawContacts.split(',').map(c => c.trim())
        : [rawContacts.trim()]

      const to = contactList.map(mail => ({
        id: mail,
        label: mail
      }))

      const agentId = this.agentId
      const cc = this.attendanceParsed?.cc ?? ''

      this.startMail({ agentId, to, cc })
    },

    updateSaveButton (formHasError) {
      this.disableSave = Boolean(formHasError)
    },

    updateContact (newVal) {
      this.contact = newVal
    }
  }

}
</script>

<style lang="sass">
.card-schedule
  .q-tab__label
    font-size: 14px

.provision
  font-weight: 500
  font-size: 18px
</style>
